export default "__VITE_ASSET__829909c6__"